import { FormType } from '../../../form-types';
import { PCOSFollowupQuestionFieldAnswers } from '../questions';

const pcosFollowup: FormType<PCOSFollowupQuestionFieldAnswers> = {
  name: 'PCOS Follow up',
  questions: [
    {
      key: 'pcosFollowup_sex',
      next: {
        condition: { 'pcosFollowup_sex.male': true },
        key: 'pcosFollowup_ineligible',
        els: 'pcosFollowup_weightHeightBMI'
      }
    },
    'pcosFollowup_weightHeightBMI',
    {
      key: 'pcosFollowup_healthChanges',
      next: {
        condition: { 'pcosFollowup_healthChanges.yes': true },
        key: 'pcosFollowup_healthChangesDetails',
        els: 'pcosFollowup_currentMedicationStatus'
      }
    },
    'pcosFollowup_healthChangesDetails',
    {
      key: 'pcosFollowup_currentMedicationStatus',
      next: {
        condition: { 'pcosFollowup_currentMedicationStatus.not_well': true },
        key: 'pcosFollowup_currentMedicationStatusDetails',
        els: 'pcosFollowup_sideEffects'
      }
    },
    'pcosFollowup_currentMedicationStatusDetails',
    {
      key: 'pcosFollowup_sideEffects',
      next: {
        condition: { 'pcosFollowup_sideEffects.yes': true },
        key: 'pcosFollowup_sideEffectsDetails',
        els: 'pcosFollowup_treatmentPreference'
      }
    },
    'pcosFollowup_sideEffectsDetails',
    'pcosFollowup_treatmentPreference',
    'pcosFollowup_otherInformation',
    {
      key: 'pcosFollowup_medicationConsent',
      next: {
        condition: { 'pcosFollowup_medicationConsent.non_consent': true },
        key: 'pcosFollowup_ineligible',
        els: 'pcosFollowup_complete'
      }
    },
    'pcosFollowup_complete',
    'pcosFollowup_ineligible'
  ]
};

export default pcosFollowup;
